.container {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

.scroll {
  overflow-x: auto;
  max-width: 100%;
}

.table {
  border-collapse: collapse;
  font-size: var(--tuna-typography-body2-fontSize);
}

.table th,
.table td {
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  border-bottom: 1px solid var(--tuna-border-subtle);
  text-align: left;
  white-space: nowrap;
}

.cards {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

.card {
  display: flex;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-subtle);
  border-radius: var(--tuna-shape-borderRadius);
}

.avatar {
  flex: none;
}

.empty,
.waiting {
  color: var(--tuna-content-secondary);
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
